module.exports = "<div class=\"cnt-back\" routerLink=\"{{backLink}}\">\n  <span class=\"wi-back-arrow icon\"></span>\n  {{text}}\n</div>"